const ReportType = [
    {
        no: 1,
        name: "บัตรวันลา"
    },
    {
        no: 2,
        name: "หนังสือรับรองวันลา"
    },
    {
        no: 3,
        name: "สรุปวันลา"
    },
    // {
    //     no: 5,
    //     name: "กราฟสรุปภาพรวม"
    // },
]

export default ReportType